// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatBackground__chat-background-brand-e9ea77 {
  --pattern: var(--pattern-brand);
  --pattern-base: var(--pattern-base-brand);
  --chat-background-average: var(--pattern-average-brand);
}

.ChatBackground__chat-background-dusk-a0cfed {
  --pattern: var(--pattern-dusk);
  --pattern-base: var(--pattern-base-dusk);
  --chat-background-average: var(--pattern-average-dusk);
}

.ChatBackground__chat-background-breeze-c2d28d {
  --pattern: var(--pattern-breeze);
  --pattern-base: var(--pattern-base-breeze);
  --chat-background-average: var(--pattern-average-breeze);
}

.ChatBackground__chat-background-bloom-ce2796 {
  --pattern: var(--pattern-bloom);
  --pattern-base: var(--pattern-base-bloom);
  --chat-background-average: var(--pattern-average-bloom);
}`, "",{"version":3,"sources":["webpack://./src/main/components/ChatBackground/ChatBackground.styles.m.css"],"names":[],"mappings":"AAAA;EACE,+BAAA;EACA,yCAAA;EACA,uDAAA;AACF;;AAEA;EACE,8BAAA;EACA,wCAAA;EACA,sDAAA;AACF;;AAEA;EACE,gCAAA;EACA,0CAAA;EACA,wDAAA;AACF;;AAEA;EACE,+BAAA;EACA,yCAAA;EACA,uDAAA;AACF","sourcesContent":[".chat-background-brand {\n  --pattern: var(--pattern-brand);\n  --pattern-base: var(--pattern-base-brand);\n  --chat-background-average: var(--pattern-average-brand);\n}\n\n.chat-background-dusk {\n  --pattern: var(--pattern-dusk);\n  --pattern-base: var(--pattern-base-dusk);\n  --chat-background-average: var(--pattern-average-dusk);\n}\n\n.chat-background-breeze {\n  --pattern: var(--pattern-breeze);\n  --pattern-base: var(--pattern-base-breeze);\n  --chat-background-average: var(--pattern-average-breeze);\n}\n\n.chat-background-bloom {\n  --pattern: var(--pattern-bloom);\n  --pattern-base: var(--pattern-base-bloom);\n  --chat-background-average: var(--pattern-average-bloom);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chat-background-brand": `ChatBackground__chat-background-brand-e9ea77`,
	"chatBackgroundBrand": `ChatBackground__chat-background-brand-e9ea77`,
	"chat-background-dusk": `ChatBackground__chat-background-dusk-a0cfed`,
	"chatBackgroundDusk": `ChatBackground__chat-background-dusk-a0cfed`,
	"chat-background-breeze": `ChatBackground__chat-background-breeze-c2d28d`,
	"chatBackgroundBreeze": `ChatBackground__chat-background-breeze-c2d28d`,
	"chat-background-bloom": `ChatBackground__chat-background-bloom-ce2796`,
	"chatBackgroundBloom": `ChatBackground__chat-background-bloom-ce2796`
};
module.exports = ___CSS_LOADER_EXPORT___;
